let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9LWeN")).then(() => parcelRequire('9nhwi'));